export const theme = {
  green: '#00d695',
  green2: '#008e63',
  gray: '#8a8a8a',
  gray2: '#212121',
  gray3: '#0e0e0e',
  black1: '#191919',
  black: '#000000',
};
